export default () => ({
    authData: null,
    authDataAddresses: [],
    orderHistory: [],
});
